// src/components/WelcomeVideoPopup.js
import React, { useState, useRef } from "react";
import "../styles/WelcomeVideoPopup.css";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// localStorage'daki token'ı düzgün çekmek için yardımcı fonksiyon
const getStoredToken = () => {
  const raw = localStorage.getItem("token");
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed === "string") return parsed;
    return raw; // parse edilemiyorsa olduğu gibi dön
  } catch {
    return raw; // düz string ise
  }
};

const WelcomeVideoPopup = ({ isOpen, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [videoEnded, setVideoEnded] = useState(false);
  const [videoDuration, setVideoDuration] = useState(0);
  const videoRef = useRef(null);

  if (!isOpen) return null;

  // Video yüklendiğinde toplam süreyi al
  const handleLoadedMetadata = () => {
    if (videoRef.current) {
      const duration = Math.floor(videoRef.current.duration || 0);
      setVideoDuration(duration);
    }
  };

  // Video bittiğinde butonu aktif et
  const handleVideoEnded = () => {
    if (videoRef.current) {
      const duration = Math.floor(
        videoRef.current.duration || videoRef.current.currentTime || 0
      );
      setVideoDuration(duration);
    }
    setVideoEnded(true);
  };

  const handleOkClick = async () => {
    const token = getStoredToken();
    if (!token) {
      console.warn("Token bulunamadı, sadece popup kapanacak.");
      onClose();
      return;
    }

    // Emin olmak için süreyi tekrar oku (olmazsa state'deki değeri kullan)
    let durationSeconds = videoDuration;
    if (videoRef.current) {
      const d = Math.floor(
        videoRef.current.duration || videoRef.current.currentTime || 0
      );
      if (d > 0) durationSeconds = d;
    }

    // 🔥 Swagger ile bire bir uyumlu payload
    const payload = {
      kullaniciID: "",                    // Swagger'da var, boş da olsa gönderiyoruz
      videoId: "1",                       // DİKKAT: string "1"
      izledi: true,                       // DİKKAT: "izledi"
      izlemeSuresiSaniye: durationSeconds,
      bitirmeTarihi: new Date().toISOString(),
      birdahaSorma: true
    };

    console.log("👉 Gönderilen payload:", payload);

    try {
      setLoading(true);

      const response = await axios.put(
        `${API_BASE_URL}/api/GirisVideo/guncelle-limited`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(
        "✅ guncelle-limited cevap:",
        response.status,
        response.data || response.statusText
      );
    } catch (err) {
      console.error("❌ GirisVideo guncelle-limited HATASI:", err);
      if (err.response) {
        console.error(
          "Response status:",
          err.response.status,
          "data:",
          err.response.data
        );
      }
    } finally {
      setLoading(false);
      onClose(); // Login tarafındaki proceedToApp burada çalışacak
    }
  };

  return (
    <div className="welcome-popup-overlay">
      <div className="welcome-popup-content">
        <h2 className="welcome-popup-title">Hoş Geldiniz!</h2>

        <div className="welcome-video-container">
          <video
            ref={videoRef}
            controls
            autoPlay
            className="welcome-video"
            onLoadedMetadata={handleLoadedMetadata}
            onEnded={handleVideoEnded}
          >
            {/* Video public/videos/hosgeldin.mp4 içinde */}
            <source src="/videos/hosgeldin.mp4" type="video/mp4" />
            Tarayıcınız video etiketini desteklemiyor.
          </video>
        </div>

        <div className="welcome-popup-footer">
          <button
            className="welcome-popup-btn"
            onClick={handleOkClick}
            disabled={!videoEnded || loading} // video bitene kadar pasif
          >
            {loading ? "Kaydediliyor..." : "Tamam"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeVideoPopup;
